import { useKyoceraRouter } from '$shared/hooks/useKyoceraRouter';

const OPTIONS = { shallow: true, scroll: false };

type UseUrlQueryState = {
    queryState?: Record<string, string[]>;
    setQueryState: (key: string, values?: string | string[]) => void;
};

const useUrlQueryState = (): UseUrlQueryState => {
    const router = useKyoceraRouter();
    const [path] = router.asPath.split('#');
    const [pathname, searchQuery] = path.split('?');
    const urlSearchParameters = new URLSearchParams(searchQuery);

    const queryState = [...urlSearchParameters.entries()].reduce<{ [key: string]: string[] }>(
        (entries, [key, value]) => {
            return {
                ...entries,
                [key]: [value],
            };
        },
        {}
    );

    const setQueryState = (key: string, val?: string | string[]) => {
        const values = Array.isArray(val) ? val : val ? [val] : [];
        const newValue = values.join(',');

        if (!newValue && !urlSearchParameters.has(key)) {
            return;
        }

        if (newValue) {
            urlSearchParameters.set(key, newValue);
        } else {
            urlSearchParameters.delete(key);
        }

        const newQueryString = urlSearchParameters.toString();
        const newUrl = `${pathname}?${newQueryString}${window.location.hash}`;

        router.replace(newUrl, undefined, OPTIONS).catch((err) => {
            if (!err.message || !err.message.includes("Cancel rendering route")) {
                console.error('Error updating URL:', err);
            }
        });
    };

    return { queryState, setQueryState };
};

export default useUrlQueryState;
